'use strict';

module.exports = function (obj) {
  return Object.keys(obj).filter(function (key) {
    return typeof obj[key] === 'function';
  });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/lib/methods.js
// module id = 136
// module chunks = 0